import React from 'react';

import { useIntl } from 'react-intl';

import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { ICON_MAP } from 'src/utils/constants';
import { useCreateEntity } from 'src/features/entity/api/useCreateEntity';
import EntityFormModal from 'src/features/entity/components/forms/EntityFormModal';
import { entityMessages } from 'src/features/entity/utils/messages';
import { LIST_ENTITIES_RESOURCE } from 'src/features/entity/api/useListEntities';
import { ENTITY_TYPE } from 'src/features/entity/types';
import { useParking } from 'src/providers/ParkingProvider';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'src/features/navigation/utils/constants';

interface CreateEntityFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateEntityPersonFormModal<TData>({ className }: CreateEntityFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();

    const { parkingId } = useParking();
    const { mutate, isPending } = useCreateEntity({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ENTITIES_RESOURCE] });
            void navigate(`/${PATH.ENTITIES}/${ENTITY_TYPE.PERSON}/${success.id}`);

            toast({
                title: formatMessage(entityMessages.createPersonEntitySuccess, {
                    entity: formatMessage(entityMessages.entity).toLowerCase(),
                }),
                description: formatMessage(entityMessages.createPersonEntitySuccessDescription, {
                    entity: formatMessage(entityMessages.entity).toLowerCase(),
                }),
            });
        },
    });

    return (
        <EntityFormModal
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, type: ENTITY_TYPE.PERSON, parkingId }, { onSuccess, onError })
            }
            type={ENTITY_TYPE.PERSON}
            title={formatMessage(entityMessages.newPersonEntity, {
                entity: formatMessage(entityMessages.entity).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(entityMessages.addPersonEntityModalSubtitle, {
                entity: formatMessage(entityMessages.entity).toLowerCase(),
            })}
        />
    );
}

export default CreateEntityPersonFormModal;
